import { render, staticRenderFns } from "./VisualizarArquivo.vue?vue&type=template&id=f69b05d2"
import script from "./VisualizarArquivo.vue?vue&type=script&lang=js"
export * from "./VisualizarArquivo.vue?vue&type=script&lang=js"
import style0 from "./VisualizarArquivo.vue?vue&type=style&index=0&id=f69b05d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports